import type {ApiQueryParams} from '@/types/api';

export const categoryKeys = {
  all: ['categories'] as const,

  lists: () => [...categoryKeys.all, 'list'] as const,
  list: (
    filters: ApiQueryParams<{
      assetId: string;
      presetId: string;
    }> = {}
  ) => [...categoryKeys.lists(), filters] as const,

  details: () => [...categoryKeys.all, 'detail'] as const,
  detail: (id: string) => [...categoryKeys.all, 'detail', id] as const,
};

export const categoryPresetKeys = {
  all: ['categoryPresets'] as const,

  lists: () => [...categoryPresetKeys.all, 'list'] as const,
  list: (filters: Pick<ApiQueryParams, 'orderBy'> = {}) =>
    [...categoryPresetKeys.lists(), filters] as const,

  details: () => [...categoryPresetKeys.all, 'detail'] as const,
  detail: (id: string) => [...categoryPresetKeys.all, 'detail', id] as const,
};

export const severityScaleKeys = {
  all: ['severityScales'] as const,

  lists: () => [...severityScaleKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams<{assetId: string}> = {}) =>
    [...severityScaleKeys.lists(), filters] as const,

  details: () => [...severityScaleKeys.all, 'detail'] as const,
  detail: (id: string) => [...severityScaleKeys.all, 'detail', id] as const,
};

export const checklistTemplateKeys = {
  all: ['checklistTemplates'] as const,

  lists: () => [...checklistTemplateKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams = {}) =>
    [...checklistTemplateKeys.lists(), filters] as const,

  details: () => [...checklistTemplateKeys.all, 'detail'] as const,
  detail: (id: string) => [...checklistTemplateKeys.all, 'detail', id] as const,
};

export const tagKeys = {
  all: ['tags'] as const,

  lists: () => [...tagKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams = {}) =>
    [...tagKeys.lists(), filters] as const,

  details: () => [...tagKeys.all, 'detail'] as const,
  detail: (id: string) => [...tagKeys.all, 'detail', id] as const,
};

export const layoutTemplateKeys = {
  all: ['layoutTemplates'] as const,

  lists: () => [...layoutTemplateKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams = {}) =>
    [...layoutTemplateKeys.lists(), filters] as const,

  details: () => [...layoutTemplateKeys.all, 'detail'] as const,
  detail: (id: string) => [...layoutTemplateKeys.all, 'detail', id] as const,

  impact: (id: string) => [...layoutTemplateKeys.detail(id), 'impact'] as const,
};
export const layerTemplateKeys = {
  all: ['layerTemplates'] as const,

  lists: () => [...layerTemplateKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams<{layoutId: string}> = {}) =>
    [...layerTemplateKeys.lists(), filters] as const,

  details: () => [...layerTemplateKeys.all, 'detail'] as const,
  detail: (id: string) => [...layerTemplateKeys.all, 'detail', id] as const,
};
